import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import style from "./ny-button.scss?inline";


@customElement('ny-button')
export class NyButton extends LitElement {

  private readonly disabled: boolean;

  // @ts-ignore
  static get properties() {
    return {
      disabled: { type: Boolean, reflect: true },
    }
  }

  constructor() {
    super();
    this.disabled = false;
  }

  // Properties available for the users of this lit-element
  @property() buttonType: string = "";
  @property() actionType: string = "";
  @property() styleOverwrite: string = "";

  // Method to obtain the button content
  getButtonContent(){
    if(this.buttonType === "icon-button"){
      return html`<slot @click=${this.handleClick} name="svg"></slot>`;
    } else if(this.buttonType === "two-line-high-width-button") {
      return html `<span class="twoLineButton">
                    <slot  @click=${this.handleClick} name="buttonLabel"></slot>
                    <slot class="subText" @click=${this.handleClick} name="buttonSubLabel"></slot>
                   </span>
      `;
    } else if(this.buttonType === "standard-width-icon-button") {
      return html `<span class="textAndIcon">
                        <slot  @click=${this.handleIconClick} name="svg"></slot>
                        <slot  @click=${this.handleClick} name="buttonLabel"></slot>
                    </span>`;
    } else {
      return html`<slot  @click=${this.handleClick} name="buttonLabel"></slot>`;
    }
  }


  render() {

    return html `
          <button style=${this.styleOverwrite} actionType=${this.actionType} buttonType=${this.buttonType} ?disabled=${this.disabled} @click=${this.handleClick}>
            ${this.getButtonContent()}
          </button>
          <style>${style}</style>
        `;
  }

  // Method to handle @click event of the icon in a disabled icon button
  private handleIconClick(e: MouseEvent) {
    if(this.disabled) {
      e.stopPropagation();
    }
  }

  // Method to disable bubbling when disabled during @click event of the button
  private handleClick(e: MouseEvent) {
    if(this.disabled) {
      e.stopImmediatePropagation();
    }
  }

}